export default function barcodeHandler(data, vm) {

    console.log("Barcode data:", data);

    if (!data) { return; }
    if (data.startsWith('customer:')) {
        const idStr = data.split(':')[1];
        vm.showByCard(idStr)
            .then((response) => {
                console.log("Cliente carregado:", response.data.data.name);
                vm.pricing();
            })
            .finally(() => {
                if (vm.customer.has_credit_available) {
                    if (vm.receivable > 0 && vm.items.length > 0) {
                        vm.payWithMethod(8);

                    }
                } else {
                    vm.showByCard(1);
                    vm.$toast.error("O cliente atingiu o limite de crédito estabelecido.");

                }
            });
        return;
    }

    const voucherMatch = data.match(/^(?:voucher|v):(\d+)$/);
    if (voucherMatch) {
        const codeStr = voucherMatch[1];
        if (vm.receivable > 0) {
            vm.showVoucher(codeStr).then((response) => {
                vm.received.name = "Voucher";
                vm.received.payment_method_id = 9;
                vm.received.amount = vm.receivable > response.data.amount ? response.data.amount : vm.receivable;
                vm.received.voucher_code = response.data.code;
                vm.processPayment(vm.received);
            }).catch((error) => {
                if (error.response) {
                    vm.$toast.error(error.response.data.error || "Erro ao validar o voucher.");
                }
            });
        }
        return;
    }

    if (vm.totalReceived > 0) {
        return;
    }

    if (vm.multiplier <= 0) { return; }


    let barcode = data.length > 3 && data.charAt(0) == 2 ? data.substring(1, 7) : data;

    axios
        .get(`/api/search/ean/${barcode}`)
        .then((response) => {
            let product = response.data.data;

            let qtyByWeight = ((1000 / product.price) * (data.substring(7, 12) / 100)) / 1000;

            let quantity = data.length > 3 && data.charAt(0) == 2 ? qtyByWeight : product.multiplier;


            if (quantity > 0) {
                vm.addProductToCart({
                    product_id: product.id,
                    distributor_id: product.distributor_id,
                    name: product.name,
                    unit: product.unit,
                    quantity: quantity * vm.multiplier,
                    unit_cost: product.cost,
                    unit_price: product.price,
                    unit_profit: product.profit,
                    wholesale_price: product.wholesale_price,
                    wholesale_profit: product.wholesale_profit,
                    wholesale_quantity: product.wholesale_quantity,
                    ean: barcode,
                    brand: product.brand,
                    original: product,
                });
            }
            vm.lastItem = product;


        })
        .catch(() => {
            vm.dialogProductError = true;
        }).finally(() => {
            vm.lastEan = barcode;
            vm.barcode = "";
            vm.dialogsearchProduct = false;
            vm.multiplier = 1;
        });



}
